import React, { useEffect } from "react";
import CardWrapper from "./CardWrapper";
import "./DataEstate.scss";
import TableCardSelector from "./TableCardSelector";
import DataTagAllFilesTable from "./DataTagAllFilesTable";
import DataTagUsersTable from "./DataTagUsersTable";
import DataEstateSummary from "./DataEstateCards/DataEstateSummary";
import DataEstateDrives from "./DataEstateDrives";
import DataEstateSizeCard from "./DataEstateCards/DataEstateSizeCard";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ALL_FILE_TYPES_DATA,
  FETCH_DATA_ESTATE_OVERVIEW,
} from "../DataTagConstants";
import DataEstateTabbedCard from "./Dataestatetabbedcard";
import DataEstateAccessCard from "./DataEstateCards/Dataestateaccesscard";

export default function DataEstate() {
  const dispatch = useDispatch();

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id,
  );

  const isDataBase = useSelector((state) => state.dataTagReducer.isDatabase);

  useEffect(() => {
    dispatch({
      type: FETCH_ALL_FILE_TYPES_DATA,
      payload: dataSourceId,
    });
  }, [dataSourceId]);

  // ONE call feeds Regulated, Sensitivity, Category and the Data Accessibility Index card
  useEffect(() => {
    if (dataSourceId) {
      dispatch({
        type: FETCH_DATA_ESTATE_OVERVIEW,
        payload: dataSourceId,
      });
    }
  }, [dataSourceId, dispatch]);

  const cards = [
    { title: "Summary", component: <DataEstateSummary /> },
    { title: "Size Analysis", component: <DataEstateSizeCard /> },
  ];

  const tabs = [
    { name: "Users", component: <DataTagUsersTable /> },
    { name: isDataBase ? "All Columns" : "All Files", component: <DataTagAllFilesTable /> },
    { name: isDataBase ? "All Tables" : "All Drives", component: <DataEstateDrives /> },
  ];

  return (
    <div className="dataEstate-container">
      <div className="de-container">
        {cards.map((card, index) => (
          <CardWrapper key={index} title={card.title} rightElement={card.rightElement}>
            {card.component}
          </CardWrapper>
        ))}

        <DataEstateTabbedCard />

        <CardWrapper title="Data Duplication & Accessibility Index">
          <DataEstateAccessCard />
        </CardWrapper>
      </div>

      <div>
        <TableCardSelector tabs={tabs} />
      </div>
    </div>
  );
}